import { UbisoftAPIService } from 'modules/ubisoft-api';
import { IPlayerHighestStats, IPlayerStatsByPlatform } from './friends-referral-store.types';

export const getHighestStat = (playerStats: IPlayerStatsByPlatform) => {
    return Object.entries(playerStats).reduce((res: IPlayerHighestStats, [platform, platformStats]) => {
        for (const [key, value] of Object.entries(platformStats)) {
            if (!res[key] || parseInt(value, 10) > parseInt(res[key].value, 10)) {
                res[key] = {
                    platform,
                    value
                };
            }
        }
        return res;
    }, {});
};

export const getCampaignSpacesByLockMode  = (
    platformLock: boolean,
    campaignSpaces: { [name: string]: string },
    platformId: string
) => {
    return platformLock ? ({ [platformId]: campaignSpaces[platformId] }) : campaignSpaces;
};

export const getPlayerStats = async (
    campaignSpaces: { [name: string]: string },
    userId: string,
    statNames: string[]): Promise<IPlayerHighestStats> => {
    const requests: Promise<IPlayerStatsByPlatform>[] = Object.entries(campaignSpaces)
        .map(async ([platform, spaceId]) => {
            const playerStat: { [name: string]: string } = await UbisoftAPIService.getStatByName({
                userId,
                spaceId,
                statName: statNames.join()
            });

            return UbisoftAPIService.generatePlayerStats(statNames, playerStat, platform);
        });
    const response = await Promise.all(requests);
    const playerStats = response.reduce((res, playerStat) => ({ ...res, ...playerStat }));

    return getHighestStat(playerStats);
};
